import AdvisoryBoard from '../../../assets/icons/advisory-board.svg?react';
import AlarmIcon from '../../../assets/icons/alarm.svg?react';
import AlertCircle from '../../../assets/icons/alert-circle.svg?react';
import AnalyzeMenuIcon from '../../../assets/icons/analyze-menu.svg?react';
import ArrowRight from '../../../assets/icons/arrow-right.svg?react';
import AttachmentIcon from '../../../assets/icons/attachment.svg?react';
import BackIcon from '../../../assets/icons/back_arrow.svg?react';
import BadResponse from '../../../assets/icons/elsie/bad-response.svg?react';
import BalloonDeflate from '../../../assets/icons/balloon-deflate.svg?react';
import BarChartSquarePlusIcon from '../../../assets/icons/bar-chart-square-plus.svg?react';
import BarLineChart from '../../../assets/icons/elsie/bar-line-chart.svg?react';
import BlueTick from '../../../assets/icons/blueTick.svg?react';
import BookmarkIcon from '../../../assets/icons/bookmark.svg?react';
import CalendarErrorIcon from '../../../assets/icons/calendar-error.svg?react';
import CalendarIcon from '../../../assets/icons/calendar.svg?react';
import CancelIcon from '../../../assets/icons/cancel.svg?react';
import CaptureMenuIcon from '../../../assets/icons/capture-menu.svg?react';
import CarretDownIcon from '../../../assets/icons/carret_down.svg?react';
import ChatBubblesIcon from '../../../assets/icons/chat-bubbles.svg?react';
import ChatIcon from '../../../assets/icons/chat-icon.svg?react';
import CheckIon from '../../../assets/icons/check.svg?react';
import CheckedBox from '../../../assets/icons/checkedBox.svg?react';
import ChevronBigDownIcon from '../../../assets/icons/chevron-big-down.svg?react';
import ChevronBigLeftIcon from '../../../assets/icons/chevron-big-left.svg?react';
import ChevronBigRightIcon from '../../../assets/icons/chevron-big-right.svg?react';
import ChevronBigUpIcon from '../../../assets/icons/chevron-big-up.svg?react';
import ChevronDownIcon from '../../../assets/icons/chevron-down.svg?react';
import ChevronFilled from '../../../assets/icons/chevron-filled.svg?react';
import ChevronLeftIcon from '../../../assets/icons/chevron-left.svg?react';
import ChevronRightIcon from '../../../assets/icons/chevron-right.svg?react';
import ChevronUpIcon from '../../../assets/icons/chevron-up.svg?react';
import Citations from '../../../assets/icons/elsie/citations.svg?react';
import CitationsIcon from '../../../assets/icons/citations.svg?react';
import ClearSearchIcon from '../../../assets/icons/clear-search.svg?react';
import ClipBoardText from '../../../assets/icons/clip-text.svg?react';
import ClockIcon from '../../../assets/icons/clock.svg?react';
import CoachMeIcon from '../../../assets/icons/coach_me.svg?react';
import CoachMeSmall from '../../../assets/icons/elsie/coach-me-small.svg?react';
import CoachMenuIcon from '../../../assets/icons/coach-menu.svg?react';
import CongressIcon from '../../../assets/icons/congress.svg?react';
import CopyIcon from '../../../assets/icons/copy.svg?react';
import CopyNew from '../../../assets/icons/elsie/copy.svg?react';
import CrossedEyeIcon from '../../../assets/icons/crossed_eye.svg?react';
import CustomCSVIcon from '../../../assets/icons/elsie/custom-csv-icon.svg?react';
import CustomExcelIcon from '../../../assets/icons/elsie/custom-excel-icon.svg?react';
import CustomPPTIcon from '../../../assets/icons/elsie/custom-powerpoint-icon.svg?react';
import CustomReportsMenuIcon from '../../../assets/icons/custom-reports-menu.svg?react';
import CustomUploadFile from '../../../assets/icons/elsie/custom-upload-file-icon.svg?react';
import DataIcon from '../../../assets/icons/data.svg?react';
import DownArrowIcon from '../../../assets/icons/down_arrow.svg?react';
import DownloadDone from '../../../assets/icons/download_done.svg?react';
import DownloadIcon from '../../../assets/icons/download.svg?react';
import EditIcon from '../../../assets/icons/edit.svg?react';
import EmailIcon from '../../../assets/icons/email.svg?react';
import EmojiCloudsIcon from '../../../assets/icons/emoji_clouds.svg?react';
import EmptySelector from '../../../assets/icons/emptySelector.svg?react';
import EraserIcon from '../../../assets/icons/erase.svg?react';
import ErrorIcon from '../../../assets/icons/error-icon.svg?react';
import ExpandIcon from '../../../assets/icons/expand-icon.svg?react';
import ExpandWidgetIcon from '../../../assets/icons/expand-widget.svg?react';
import ExportCSVIcon from '../../../assets/icons/export-csv.svg?react';
import ExportPPTXIcon from '../../../assets/icons/export-pptx.svg?react';
import EyeIcon from '../../../assets/icons/eye.svg?react';
import FileBlackIcon from '../../../assets/icons/file_black.svg?react';
import FileFind from '../../../assets/icons/file_find.svg?react';
import FileSmall from '../../../assets/icons/elsie/file-06-small.svg?react';
import FilterIcon from '../../../assets/icons/filter.svg?react';
import Filters from '../../../assets/icons/elsie/filter.svg?react';
import FolderDownload from '../../../assets/icons/folder-download.svg?react';
import FullScreen from '../../../assets/icons/elsie/maximize-01.svg?react';
import GoodResponse from '../../../assets/icons/elsie/good-response.svg?react';
import GridBigRoundIcon from '../../../assets/icons/grid-big-round.svg?react';
import GroupInsightsIcon from '../../../assets/icons/group-insights.svg?react';
import HamburgerIcon from '../../../assets/icons/hamburger.svg?react';
import HomeIcon from '../../../assets/icons/home.svg?react';
import HomeLineIcon from '../../../assets/icons/home-line.svg?react';
import HourGlassTimer from '../../../assets/icons/hourglass-timer.svg?react';
import IndeterminateBox from '../../../assets/icons/indeterminateBox.svg?react';
import InfoRoundedIcon from '../../../assets/icons/info_rounded.svg?react';
import InsightGroupIcon from '../../../assets/icons/insight-group.svg?react';
import InsightsIcon from '../../../assets/icons/insights-icon.svg?react';
import InsightsLegacyMenuIcon from '../../../assets/icons/insights-legacy-menu.svg?react';
import InsightsLightBulbIcon from '../../../assets/icons/insights_light_bulb.svg?react';
import InsightsMenuIcon from '../../../assets/icons/insights-menu.svg?react';
import KwelloLogoIcon from '../../../assets/icons/kwello-logo.svg?react';
import KwelloLogoIconOnly from '../../../assets/icons/kwello-logo-icon-only.svg?react';
import LeftArrow from '../../../assets/icons/left-arrow.svg?react';
import LifeBuoy from '../../../assets/icons/life-buoy.svg?react';
import LightBulbIcon from '../../../assets/icons/light-bulb.svg?react';
import LightningIcon from '../../../assets/icons/lightning.svg?react';
import ListAddIcon from '../../../assets/icons/list-add.svg?react';
import ListIcon from '../../../assets/icons/list.svg?react';
import LocationPinIcon from '../../../assets/icons/location_pin.svg?react';
import LogOutIcon from '../../../assets/icons/log-out.svg?react';
import LoginIcon from '../../../assets/icons/login.svg?react';
import LoginTriangles from '../../../assets/icons/login-triangles.svg?react';
import MagnifierIcon from '../../../assets/icons/magnifier.svg?react';
import MajorConferenceIcon from '../../../assets/icons/major-conference.svg?react';
import MessageIcon from '../../../assets/icons/message.svg?react';
import MinusIcon from '../../../assets/icons/minus.svg?react';
import MobileDevice from '../../../assets/icons/mobile-device.svg?react';
import MoreHorizontalIcon from '../../../assets/icons/more-horizontal.svg?react';
import MoreVerticalIcon from '../../../assets/icons/more-vertical.svg?react';
import NavigateArrow from '../../../assets/icons/navigate-arrow.svg?react';
import NeutralIcon from '../../../assets/icons/neutral.svg?react';
import NoDataState from '../../../assets/icons/no-data-state.svg?react';
import NoEntry from '../../../assets/icons/no-entry.svg?react';
import NotificationDeactivatedIcon from '../../../assets/icons/notification_deactivated.svg?react';
import NotificationIcon from '../../../assets/icons/notification.svg?react';
import OfficeVisitIcon from '../../../assets/icons/office-visit.svg?react';
import OpenArrowIcon from '../../../assets/icons/open-arrow.svg?react';
import OrganicInsight from '../../../assets/icons/organic_insight.svg?react';
import OtherChannelIcon from '../../../assets/icons/other-channel.svg?react';
import OutOfOfficeIcon from '../../../assets/icons/out-of-office-live.svg?react';
import PaperClip from '../../../assets/icons/paperclip.svg?react';
import PdfIcon from '../../../assets/icons/pdf.svg?react';
import PeopleGroup from '../../../assets/icons/people-group.svg?react';
import PermissionPadlock from '../../../assets/icons/permission_padlock.svg?react';
import PersonFilterIcon from '../../../assets/icons/person-filter.svg?react';
import PhoneIcon from '../../../assets/icons/phone.svg?react';
import PieChartIcon from '../../../assets/icons/pie-chart.svg?react';
import PieChartPlusIcon from '../../../assets/icons/pie-chart-plus.svg?react';
import PlanMenuIcon from '../../../assets/icons/plan-menu.svg?react';
import PlanningMenuIcon from '../../../assets/icons/planning-menu.svg?react';
import PlusCircleIcon from '../../../assets/icons/plus_circle_icon.svg?react';
import PlusIcon from '../../../assets/icons/plus.svg?react';
import PopupCloseIcon from '../../../assets/icons/popup-close.svg?react';
import PositiveIcon from '../../../assets/icons/positive.svg?react';
import ProfileAddIcon from '../../../assets/icons/profile-add.svg?react';
import ProfileGroupIcon from '../../../assets/icons/profile-group.svg?react';
import PromptIdeas from '../../../assets/icons/elsie/annotation-dots.svg?react';
import PromptIdeasIcon from '../../../assets/icons/prompt_ideas.svg?react';
import PuzzlePiecesIcon from '../../../assets/icons/puzzle_pieces.svg?react';
import QuestionMark from '../../../assets/icons/question-mark.svg?react';
import ReOrderHandle from '../../../assets/icons/re-order-handle.svg?react';
import RefreshArrow from '../../../assets/icons/refresh-arrow.svg?react';
import ReloadIcon from '../../../assets/icons/reload.svg?react';
import ReportMenuIcon from '../../../assets/icons/report-menu.svg?react';
import ResponseDetailsIcon from '../../../assets/icons/response-details-icon.svg?react';
import RightArrowCircle from '../../../assets/icons/right-arrow-circle.svg?react';
import RightArrowCircleOutline from '../../../assets/icons/right-arrow-circle-outline.svg?react';
import SaveIcon from '../../../assets/icons/save-disc.svg?react';
import SearchForIcon from '../../../assets/icons/search_for_vector.svg?react';
import SearchIcon from '../../../assets/icons/search.svg?react';
import SendFillIcon from '../../../assets/icons/send-fill.svg?react';
import SendMessage from '../../../assets/icons/elsie/send-message.svg?react';
import SettingsIcon from '../../../assets/icons/settings.svg?react';
import SocialMenuIcon from '../../../assets/icons/social-menu.svg?react';
import SortIcon from '../../../assets/icons/alpha-sort.svg?react';
import SosvExpertsMenuIcon from '../../../assets/icons/sosv-experts-menu.svg?react';
import SosvScienceMenuIcon from '../../../assets/icons/sosv-science-menu.svg?react';
import SummarizeIcon from '../../../assets/icons/summarize.svg?react';
import TableIcon from '../../../assets/icons/table.svg?react';
import TagOutlineIcon from '../../../assets/icons/tag-outline.svg?react';
import ThumbsDownIcon from '../../../assets/icons/thumbs-down.svg?react';
import ThumbsUpIcon from '../../../assets/icons/thumbs-up.svg?react';
import TickCircle from '../../../assets/icons/tickCircle.svg?react';
import TickUnderlineIcon from '../../../assets/icons/tick_underline.svg?react';
import TimerIcon from '../../../assets/icons/timer.svg?react';
import ToggleTable from '../../../assets/icons/elsie/layout-grid.svg?react';
import TransparentArrow from '../../../assets/icons/transparent-arrow.svg?react';
import TrashBinIcon from '../../../assets/icons/trash-bin.svg?react';
import UnCheckedBox from '../../../assets/icons/uncheckedBox.svg?react';
import UnderlinedTickIcon from '../../../assets/icons/underlined_tick.svg?react';
import UniversalFilterIcon from '../../../assets/icons/universal-filters-icon.svg?react';
import UpArrowIcon from '../../../assets/icons/up_arrow.svg?react';
import UserAvatarDefault from '../../../assets/user-avatar-default.svg?react';
import UserIcon from '../../../assets/icons/user.svg?react';
import ViewSourceIcon from '../../../assets/icons/view-source.svg?react';
import VirtualIcon from '../../../assets/icons/virtual.svg?react';
import WarningIcon from '../../../assets/icons/warning.svg?react';
import WarningTriangleIcon from '../../../assets/icons/warning-triangle.svg?react';
import WhiteArrowSolidCircle from '../../../assets/icons/white-arrow-solid-circle.svg?react';
import WhiteCrossSolidCircle from '../../../assets/icons/white_cross_circle.svg?react';
import WorkshopIcon from '../../../assets/icons/workshop.svg?react';
import XBigIcon from '../../../assets/icons/x-big.svg?react';
import XClose from '../../../assets/icons/x-close.svg?react';
import XIcon from '../../../assets/icons/x.svg?react';
import LightBulb2 from '../../../assets/icons/elsie/lightbulb-02.svg?react';
import { SVGIcon } from '@progress/kendo-svg-icons';
import { CSSProperties } from 'react';

// --- Alphabetize KWELLO_ICON enum ---
export enum KWELLO_ICON {
  ADVISORY_BOARD = 'advisory-board',
  ALARM_ICON = 'alarm-icon',
  ALERT_CIRCLE = 'alert-circle',
  ANALYZE_MENU_ICON = 'analyze-menu-icon',
  ARROW_LEFT = 'left-arrow-icon',
  ARROW_RIGHT = 'arrow-right',
  ATTACHMENT_ICON = 'attachment-icon',
  BACK_ICON = 'back_arrow',
  BALLOON_DEFLATE = 'balloon_deflate',
  BAR_CHART_SQUARE_PLUS_ICON = 'bar-chart-square-plus',
  BAR_LINE_CHART = 'bar-line-chart',
  BLUE_TICK_ICON = 'blue-tick-icon',
  BOOKMARK_ICON = 'bookmark-icon',
  CALENDAR_ERROR_ICON = 'calendar-error-icon',
  CALENDAR_ICON = 'calendar-icon',
  CANCEL_ICON = 'cancel',
  CAPTURE_MENU_ICON = 'capture-menu-icon',
  CARRET_DOWN = 'carret-down',
  CHAT_BUBBLES_ICON = 'chat-bubbles-icon',
  CHAT_ICON = 'chat-icon',
  CHECKED_BOX = 'checked-box-icon',
  CHECK_ICON = 'check',
  CHEVRON_BIG_DOWN_ICON = 'chevron-big-down-icon',
  CHEVRON_BIG_LEFT_ICON = 'chevron-big-left-icon',
  CHEVRON_BIG_RIGHT_ICON = 'chevron-big-right-icon',
  CHEVRON_BIG_UP_ICON = 'chevron-big-up-icon',
  CHEVRON_DOWN_ICON = 'chevron-down-icon',
  CHEVRON_FILLED = 'chevron-filled',
  CHEVRON_LEFT_ICON = 'chevron-left-icon',
  CHEVRON_RIGHT_ICON = 'chevron-right-icon',
  CHEVRON_UP_ICON = 'chevron-up-icon',
  CITATIONS = 'citations',
  CLEAR_SEARCH_ICON = 'clear-search-icon',
  CLIP_BOARD_TEXT = 'clip-board-text',
  CLOCK = 'clock',
  COACH_MENU_ICON = 'coach-menu-icon',
  COACH_ME_ICON = 'coach-me',
  CONGRESS_ICON = 'congress-icon',
  COPY_ICON = 'copy',
  CROSSED_EYE_ICON = 'crossed-eye-icon',
  CUSTOM_REPORTS_MENU_ICON = 'custom-reports-menu-icon',
  DATA_ICON = 'data-icon',
  DATA_LOAD_ERROR_ICON = 'error-icon',
  DOWNLOAD_DONE = 'download_done',
  DOWNLOAD_ICON = 'download-icon',
  DOWN_ARROW = 'down-arrow',
  EDIT_ICON = 'edit-icon',
  EMAIL_ICON = 'email-icon',
  EMOJI_CLOUDS_ICON = 'emoji-clouds-icon',
  EMPTY_SELECTOR_ICON = 'empty-selector-icon',
  ERASER_ICON = 'eraser-icon',
  EXPAND_ICON = 'expand-icon',
  EXPAND_WIDGET_ICON = 'expand-widget-icon',
  EXPORT_CSV_ICON = 'export-csv-icon',
  EXPORT_PPTX_ICON = 'export-pptx-icon',
  EYE_ICON = 'eye-icon',
  FILE_BLACK_ICON = 'file-black-icon',
  FILE_FIND = 'file_find',
  FILTER_ICON = 'filter-icon',
  FOLDER_DOWNLOAD = 'folder-download',
  GRID_BIG_ROUND_ICON = 'grid-big-round-icon',
  GROUP_INSIGHTS_ICON = 'group-insights-icon',
  HAMBURGER_ICON = 'hamburger-icon',
  HOME_ICON = 'home-icon',
  HOME_SOLID_ICON = 'home-slid-icon',
  HOURGLASS_TIMER = 'hour-glass-timer',
  INDETERMINATE_BOX = 'indeterminate-box-icon',
  INFO_ROUNDED_ICON = 'info_rounded-icon',
  INSIGHTS_ICON = 'insights-icon',
  INSIGHTS_LEGACY_MENU_ICON = 'insights-legacy-menu-icon',
  INSIGHTS_LIGHT_BULB_ICON = 'insights-light-bulb-icon',
  INSIGHT_GROUP_ICON = 'insight-group-icon',
  INSIGHT_MENU_ICON = 'insights-menu-icon',
  KWELLO_LOGO = 'kwello-logo',
  KWELLO_LOGO_ICON_ONLY = 'kwello-logo-icon-only',
  LIFE_BUOY = 'life-buoy',
  LIGHTNING_ICON = 'lightning-icon',
  LIGHT_BULB_ICON = 'light-bulb-icon',
  LIST_ADD_ICON = 'list-add-icon',
  LIST_ICON = 'list-icon',
  LOCATION_PIN_ICON = 'location-pin-icon',
  LOGIN_ICON = 'login-icon',
  LOGIN_TRIANGLES = 'login-triangles',
  LOG_OUT_ICON = 'log-out-icon',
  MAGNIFIER_ICON = 'magnifier-icon',
  MAJOR_CONFERENCE_ICON = 'major-conference-icon',
  MESSAGE_ICON = 'message-icon',
  MINUS_ICON = 'minus-icon',
  MOBILE_DEVICE = 'mobile-device',
  MORE_HORIZONTAL_ICON = 'more-horizontal-icon',
  MORE_VERTICAL_ICON = 'more-vertical-icon',
  NAVIGATE_ARROW = 'navigate-arrow',
  NEUTRAL_ICON = 'neutral-icon',
  NOTIFICATION_DEACTIVATED_ICON = 'notification-deactivated-icon',
  NOTIFICATION_ICON = 'notification-icon',
  NO_DATA = 'no-data-state',
  NO_ENTRY = 'no-entry',
  OFFICE_VISIT_ICON = 'office-visit-icon',
  OPEN_ARROW_ICON = 'open-arrow-icon',
  ORGANIC_INSIGHT = 'organic-insight',
  OTHER_CHANNEL_ICON = 'other-channel-icon',
  OUT_OF_OFFICE_ICON = 'out-of-office-icon',
  PAPERCLIP_ICON = 'paperclip-icon',
  PDF_ICON = 'pdf-icon',
  PEOPLE_GROUP = 'people-group',
  PERMISSION_PADLOCK = 'permission-padlock',
  PERSON_FILTER_ICON = 'person-filter-icon',
  PHONE_ICON = 'phone-icon',
  PIE_CHART_ICON = 'pie-chart-icon',
  PIE_CHART_PLUS_ICON = 'pie-chart-plus-icon',
  PLANNING_MENU_ICON = 'planning-menu-icon',
  PLAN_MENU_ICON = 'plan-menu-icon',
  PLUS_CIRCLE = 'plus_circle',
  PLUS_ICON = 'plus-icon',
  POPUP_CLOSE_ICON = 'popup-close-icon',
  POSITIVE_ICON = 'positive-icon',
  PROFILE_ADD_ICON = 'profile-add-icon',
  PROFILE_GROUP_ICON = 'profile-group-icon',
  PROMPT_IDEAS_ICON = 'prompt-ideas',
  PUZZLE_PIECES_ICON = 'puzzle-pieces-icon',
  QUESTIONMARK_ICON = 'questionmark-icon',
  REFRESH_ARROW = 'refresh-arrow',
  RELOAD_ICON = 'reload-icon',
  REPORT_MENU_ICON = 'report-menu-icon',
  RESPONSE_DETAILS_ICON = 'response-details-icon',
  RE_ORDER_HANDLE = 're-order-handle',
  RIGHT_ARROW_CIRCLE = 'right-arrow-circle',
  RIGHT_ARROW_CIRCLE_OUTLINE = 'right-arrow-circle-outline',
  SAVE_ICON = 'save-icon',
  SEARCH_FOR_ICON = 'search-for-icon',
  SEARCH_ICON = 'search-icon',
  SEND_FILL_ICON = 'send-fill',
  SETTINGS_ICON = 'settings-icon',
  SOCIAL_MENU_ICON = 'social-menu-icon',
  SORT_ICON = 'sort-icon',
  SOSV_EXPERTS_MENU_ICON = 'sosv-experts-menu-icon',
  SOSV_SCIENCE_MENU_ICON = 'sosv-science-menu-icon',
  SUMMMARIZE = 'summary',
  TABLE_ICON = 'table-icon',
  TAG_OUTLINE_ICON = 'tag-outline-icon',
  THUMBS_DOWN_ICON = 'thumbs-down',
  THUMBS_UP_ICON = 'thumbs-up',
  TICK_CIRCLE_ICON = 'tick-circle',
  TICK_UNDERLINE_ICON = 'tick-underline-icon',
  TIMER_ICON = 'timer-icon',
  TOGGLE_TABLE = 'toggle-table',
  TRANSPARENT_ARROW = 'transparent-arrow',
  TRASH_BIN_ICON = 'trash-bin-icon',
  UNCHECKED_BOX = 'unchecked-box-icon',
  UNDERLINED_TICK_ICON = 'underlined-tick-icon',
  UNIVERSAL_FILTERS_ICON = 'universal-filters-icon',
  UP_ARROW = 'up-arrow',
  USER_AVATAR_DEFAULT = 'user-avatar-default',
  USER_ICON = 'user',
  VIEW_SOURCE_ICON = 'view-source',
  VIRTUAL_ICON = 'virtual-icon',
  WARNING_ICON = 'warning-icon',
  WARNING_TRIANGLE_ICON = 'warning-triangle-icon',
  WHITE_ARROW_SOLID_CIRCLE = 'white-arrow-solid-circle',
  WHITE_CROSS_SOLID_CIRCLE = 'white-cross-solid-cirle',
  WORKSHOP_ICON = 'workshop-icon',
  X_BIG_ICON = 'x-big-icon',
  X_CLOSE = 'x-close',
  X_ICON = 'x-icon',
}
// --- Alphabetize KWELLO_ELSIE_ICON enum ---
export enum KWELLO_ELSIE_ICON {
  BAD_RESPONSE = 'bad-response',
  CITATIONS_NEW = 'citations-new',
  COACH_ME_SMALL = 'coach-me-small',
  COPY = 'copy-new',
  CSV_ICON = 'csv-icon',
  EXCEL_ICON = 'excel-icon',
  FILE_SMALL = 'file-small',
  FILTERS = 'filters',
  FULL_SCREEN = 'full-screen',
  GOOD_RESPONSE = 'good-response',
  LIGHT_BULB = 'light-bulb-02',
  PPT_ICON = 'ppt-icon',
  PROMPT_IDEAS = 'prompts',
  SEND_MESSAGE = 'send-message',
  UPLOADFILE_ICON = 'uploadfile-icon',
}
// --- Alphabetize SVG_ICON_MAP keys ---
const SVG_ICON_MAP = {
  [KWELLO_ELSIE_ICON.BAD_RESPONSE]: BadResponse,
  [KWELLO_ELSIE_ICON.CITATIONS_NEW]: Citations,
  [KWELLO_ELSIE_ICON.COACH_ME_SMALL]: CoachMeSmall,
  [KWELLO_ELSIE_ICON.COPY]: CopyNew,
  [KWELLO_ELSIE_ICON.CSV_ICON]: CustomCSVIcon,
  [KWELLO_ELSIE_ICON.EXCEL_ICON]: CustomExcelIcon,
  [KWELLO_ELSIE_ICON.FILE_SMALL]: FileSmall,
  [KWELLO_ELSIE_ICON.FILTERS]: Filters,
  [KWELLO_ELSIE_ICON.FULL_SCREEN]: FullScreen,
  [KWELLO_ELSIE_ICON.GOOD_RESPONSE]: GoodResponse,
  [KWELLO_ELSIE_ICON.LIGHT_BULB]: LightBulb2,
  [KWELLO_ELSIE_ICON.PPT_ICON]: CustomPPTIcon,
  [KWELLO_ELSIE_ICON.PROMPT_IDEAS]: PromptIdeas,
  [KWELLO_ELSIE_ICON.SEND_MESSAGE]: SendMessage,
  [KWELLO_ELSIE_ICON.UPLOADFILE_ICON]: CustomUploadFile,
  [KWELLO_ICON.ADVISORY_BOARD]: AdvisoryBoard,
  [KWELLO_ICON.ALARM_ICON]: AlarmIcon,
  [KWELLO_ICON.ALERT_CIRCLE]: AlertCircle,
  [KWELLO_ICON.ANALYZE_MENU_ICON]: AnalyzeMenuIcon,
  [KWELLO_ICON.ARROW_LEFT]: LeftArrow,
  [KWELLO_ICON.ARROW_RIGHT]: ArrowRight,
  [KWELLO_ICON.ATTACHMENT_ICON]: AttachmentIcon,
  [KWELLO_ICON.BACK_ICON]: BackIcon,
  [KWELLO_ICON.BALLOON_DEFLATE]: BalloonDeflate,
  [KWELLO_ICON.BAR_CHART_SQUARE_PLUS_ICON]: BarChartSquarePlusIcon,
  [KWELLO_ICON.BAR_LINE_CHART]: BarLineChart,
  [KWELLO_ICON.BLUE_TICK_ICON]: BlueTick,
  [KWELLO_ICON.BOOKMARK_ICON]: BookmarkIcon,
  [KWELLO_ICON.CALENDAR_ERROR_ICON]: CalendarErrorIcon,
  [KWELLO_ICON.CALENDAR_ICON]: CalendarIcon,
  [KWELLO_ICON.CANCEL_ICON]: CancelIcon,
  [KWELLO_ICON.CAPTURE_MENU_ICON]: CaptureMenuIcon,
  [KWELLO_ICON.CARRET_DOWN]: CarretDownIcon,
  [KWELLO_ICON.CHAT_BUBBLES_ICON]: ChatBubblesIcon,
  [KWELLO_ICON.CHAT_ICON]: ChatIcon,
  [KWELLO_ICON.CHECKED_BOX]: CheckedBox,
  [KWELLO_ICON.CHECK_ICON]: CheckIon,
  [KWELLO_ICON.CHEVRON_BIG_DOWN_ICON]: ChevronBigDownIcon,
  [KWELLO_ICON.CHEVRON_BIG_LEFT_ICON]: ChevronBigLeftIcon,
  [KWELLO_ICON.CHEVRON_BIG_RIGHT_ICON]: ChevronBigRightIcon,
  [KWELLO_ICON.CHEVRON_BIG_UP_ICON]: ChevronBigUpIcon,
  [KWELLO_ICON.CHEVRON_DOWN_ICON]: ChevronDownIcon,
  [KWELLO_ICON.CHEVRON_FILLED]: ChevronFilled,
  [KWELLO_ICON.CHEVRON_LEFT_ICON]: ChevronLeftIcon,
  [KWELLO_ICON.CHEVRON_RIGHT_ICON]: ChevronRightIcon,
  [KWELLO_ICON.CHEVRON_UP_ICON]: ChevronUpIcon,
  [KWELLO_ICON.CITATIONS]: CitationsIcon,
  [KWELLO_ICON.CLEAR_SEARCH_ICON]: ClearSearchIcon,
  [KWELLO_ICON.CLIP_BOARD_TEXT]: ClipBoardText,
  [KWELLO_ICON.CLOCK]: ClockIcon,
  [KWELLO_ICON.COACH_MENU_ICON]: CoachMenuIcon,
  [KWELLO_ICON.COACH_ME_ICON]: CoachMeIcon,
  [KWELLO_ICON.CONGRESS_ICON]: CongressIcon,
  [KWELLO_ICON.COPY_ICON]: CopyIcon,
  [KWELLO_ICON.CROSSED_EYE_ICON]: CrossedEyeIcon,
  [KWELLO_ICON.CUSTOM_REPORTS_MENU_ICON]: CustomReportsMenuIcon,
  [KWELLO_ICON.DATA_ICON]: DataIcon,
  [KWELLO_ICON.DOWNLOAD_DONE]: DownloadDone,
  [KWELLO_ICON.DOWNLOAD_ICON]: DownloadIcon,
  [KWELLO_ICON.DOWN_ARROW]: DownArrowIcon,
  [KWELLO_ICON.EDIT_ICON]: EditIcon,
  [KWELLO_ICON.EMAIL_ICON]: EmailIcon,
  [KWELLO_ICON.EMOJI_CLOUDS_ICON]: EmojiCloudsIcon,
  [KWELLO_ICON.EMPTY_SELECTOR_ICON]: EmptySelector,
  [KWELLO_ICON.ERASER_ICON]: EraserIcon,
  [KWELLO_ICON.DATA_LOAD_ERROR_ICON]: ErrorIcon,
  [KWELLO_ICON.EXPAND_ICON]: ExpandIcon,
  [KWELLO_ICON.EXPAND_WIDGET_ICON]: ExpandWidgetIcon,
  [KWELLO_ICON.EXPORT_CSV_ICON]: ExportCSVIcon,
  [KWELLO_ICON.EXPORT_PPTX_ICON]: ExportPPTXIcon,
  [KWELLO_ICON.EYE_ICON]: EyeIcon,
  [KWELLO_ICON.FILE_BLACK_ICON]: FileBlackIcon,
  [KWELLO_ICON.FILE_FIND]: FileFind,
  [KWELLO_ICON.FILTER_ICON]: FilterIcon,
  [KWELLO_ICON.FOLDER_DOWNLOAD]: FolderDownload,
  [KWELLO_ICON.GRID_BIG_ROUND_ICON]: GridBigRoundIcon,
  [KWELLO_ICON.GROUP_INSIGHTS_ICON]: GroupInsightsIcon,
  [KWELLO_ICON.HAMBURGER_ICON]: HamburgerIcon,
  [KWELLO_ICON.HOME_ICON]: HomeLineIcon,
  [KWELLO_ICON.HOME_SOLID_ICON]: HomeIcon,
  [KWELLO_ICON.HOURGLASS_TIMER]: HourGlassTimer,
  [KWELLO_ICON.INDETERMINATE_BOX]: IndeterminateBox,
  [KWELLO_ICON.INFO_ROUNDED_ICON]: InfoRoundedIcon,
  [KWELLO_ICON.INSIGHTS_ICON]: InsightsIcon,
  [KWELLO_ICON.INSIGHTS_LEGACY_MENU_ICON]: InsightsLegacyMenuIcon,
  [KWELLO_ICON.INSIGHTS_LIGHT_BULB_ICON]: InsightsLightBulbIcon,
  [KWELLO_ICON.INSIGHT_GROUP_ICON]: InsightGroupIcon,
  [KWELLO_ICON.INSIGHT_MENU_ICON]: InsightsMenuIcon,
  [KWELLO_ICON.KWELLO_LOGO]: KwelloLogoIcon,
  [KWELLO_ICON.KWELLO_LOGO_ICON_ONLY]: KwelloLogoIconOnly,
  [KWELLO_ICON.LIFE_BUOY]: LifeBuoy,
  [KWELLO_ICON.LIGHTNING_ICON]: LightningIcon,
  [KWELLO_ICON.LIGHT_BULB_ICON]: LightBulbIcon,
  [KWELLO_ICON.LIST_ADD_ICON]: ListAddIcon,
  [KWELLO_ICON.LIST_ICON]: ListIcon,
  [KWELLO_ICON.LOCATION_PIN_ICON]: LocationPinIcon,
  [KWELLO_ICON.LOGIN_ICON]: LoginIcon,
  [KWELLO_ICON.LOGIN_TRIANGLES]: LoginTriangles,
  [KWELLO_ICON.LOG_OUT_ICON]: LogOutIcon,
  [KWELLO_ICON.MAGNIFIER_ICON]: MagnifierIcon,
  [KWELLO_ICON.MAJOR_CONFERENCE_ICON]: MajorConferenceIcon,
  [KWELLO_ICON.MESSAGE_ICON]: MessageIcon,
  [KWELLO_ICON.MINUS_ICON]: MinusIcon,
  [KWELLO_ICON.MOBILE_DEVICE]: MobileDevice,
  [KWELLO_ICON.MORE_HORIZONTAL_ICON]: MoreHorizontalIcon,
  [KWELLO_ICON.MORE_VERTICAL_ICON]: MoreVerticalIcon,
  [KWELLO_ICON.NAVIGATE_ARROW]: NavigateArrow,
  [KWELLO_ICON.NEUTRAL_ICON]: NeutralIcon,
  [KWELLO_ICON.NOTIFICATION_DEACTIVATED_ICON]: NotificationDeactivatedIcon,
  [KWELLO_ICON.NOTIFICATION_ICON]: NotificationIcon,
  [KWELLO_ICON.NO_DATA]: NoDataState,
  [KWELLO_ICON.NO_ENTRY]: NoEntry,
  [KWELLO_ICON.OFFICE_VISIT_ICON]: OfficeVisitIcon,
  [KWELLO_ICON.OPEN_ARROW_ICON]: OpenArrowIcon,
  [KWELLO_ICON.ORGANIC_INSIGHT]: OrganicInsight,
  [KWELLO_ICON.OTHER_CHANNEL_ICON]: OtherChannelIcon,
  [KWELLO_ICON.OUT_OF_OFFICE_ICON]: OutOfOfficeIcon,
  [KWELLO_ICON.PAPERCLIP_ICON]: PaperClip,
  [KWELLO_ICON.PDF_ICON]: PdfIcon,
  [KWELLO_ICON.PEOPLE_GROUP]: PeopleGroup,
  [KWELLO_ICON.PERMISSION_PADLOCK]: PermissionPadlock,
  [KWELLO_ICON.PERSON_FILTER_ICON]: PersonFilterIcon,
  [KWELLO_ICON.PHONE_ICON]: PhoneIcon,
  [KWELLO_ICON.PIE_CHART_ICON]: PieChartIcon,
  [KWELLO_ICON.PIE_CHART_PLUS_ICON]: PieChartPlusIcon,
  [KWELLO_ICON.PLANNING_MENU_ICON]: PlanningMenuIcon,
  [KWELLO_ICON.PLAN_MENU_ICON]: PlanMenuIcon,
  [KWELLO_ICON.PLUS_CIRCLE]: PlusCircleIcon,
  [KWELLO_ICON.PLUS_ICON]: PlusIcon,
  [KWELLO_ICON.POPUP_CLOSE_ICON]: PopupCloseIcon,
  [KWELLO_ICON.POSITIVE_ICON]: PositiveIcon,
  [KWELLO_ICON.PROFILE_ADD_ICON]: ProfileAddIcon,
  [KWELLO_ICON.PROFILE_GROUP_ICON]: ProfileGroupIcon,
  [KWELLO_ICON.PROMPT_IDEAS_ICON]: PromptIdeasIcon,
  [KWELLO_ICON.PUZZLE_PIECES_ICON]: PuzzlePiecesIcon,
  [KWELLO_ICON.QUESTIONMARK_ICON]: QuestionMark,
  [KWELLO_ICON.REFRESH_ARROW]: RefreshArrow,
  [KWELLO_ICON.RELOAD_ICON]: ReloadIcon,
  [KWELLO_ICON.REPORT_MENU_ICON]: ReportMenuIcon,
  [KWELLO_ICON.RESPONSE_DETAILS_ICON]: ResponseDetailsIcon,
  [KWELLO_ICON.RE_ORDER_HANDLE]: ReOrderHandle,
  [KWELLO_ICON.RIGHT_ARROW_CIRCLE]: RightArrowCircle,
  [KWELLO_ICON.RIGHT_ARROW_CIRCLE_OUTLINE]: RightArrowCircleOutline,
  [KWELLO_ICON.SAVE_ICON]: SaveIcon,
  [KWELLO_ICON.SEARCH_FOR_ICON]: SearchForIcon,
  [KWELLO_ICON.SEARCH_ICON]: SearchIcon,
  [KWELLO_ICON.SEND_FILL_ICON]: SendFillIcon,
  [KWELLO_ICON.SETTINGS_ICON]: SettingsIcon,
  [KWELLO_ICON.SOCIAL_MENU_ICON]: SocialMenuIcon,
  [KWELLO_ICON.SORT_ICON]: SortIcon,
  [KWELLO_ICON.SOSV_EXPERTS_MENU_ICON]: SosvExpertsMenuIcon,
  [KWELLO_ICON.SOSV_SCIENCE_MENU_ICON]: SosvScienceMenuIcon,
  [KWELLO_ICON.SUMMMARIZE]: SummarizeIcon,
  [KWELLO_ICON.TABLE_ICON]: TableIcon,
  [KWELLO_ICON.TAG_OUTLINE_ICON]: TagOutlineIcon,
  [KWELLO_ICON.THUMBS_DOWN_ICON]: ThumbsDownIcon,
  [KWELLO_ICON.THUMBS_UP_ICON]: ThumbsUpIcon,
  [KWELLO_ICON.TICK_CIRCLE_ICON]: TickCircle,
  [KWELLO_ICON.TICK_UNDERLINE_ICON]: TickUnderlineIcon,
  [KWELLO_ICON.TIMER_ICON]: TimerIcon,
  [KWELLO_ICON.TOGGLE_TABLE]: ToggleTable,
  [KWELLO_ICON.TRANSPARENT_ARROW]: TransparentArrow,
  [KWELLO_ICON.TRASH_BIN_ICON]: TrashBinIcon,
  [KWELLO_ICON.UNCHECKED_BOX]: UnCheckedBox,
  [KWELLO_ICON.UNDERLINED_TICK_ICON]: UnderlinedTickIcon,
  [KWELLO_ICON.UNIVERSAL_FILTERS_ICON]: UniversalFilterIcon,
  [KWELLO_ICON.UP_ARROW]: UpArrowIcon,
  [KWELLO_ICON.USER_AVATAR_DEFAULT]: UserAvatarDefault,
  [KWELLO_ICON.USER_ICON]: UserIcon,
  [KWELLO_ICON.VIEW_SOURCE_ICON]: ViewSourceIcon,
  [KWELLO_ICON.VIRTUAL_ICON]: VirtualIcon,
  [KWELLO_ICON.WARNING_ICON]: WarningIcon,
  [KWELLO_ICON.WARNING_TRIANGLE_ICON]: WarningTriangleIcon,
  [KWELLO_ICON.WHITE_ARROW_SOLID_CIRCLE]: WhiteArrowSolidCircle,
  [KWELLO_ICON.WHITE_CROSS_SOLID_CIRCLE]: WhiteCrossSolidCircle,
  [KWELLO_ICON.WORKSHOP_ICON]: WorkshopIcon,
  [KWELLO_ICON.X_BIG_ICON]: XBigIcon,
  [KWELLO_ICON.X_CLOSE]: XClose,
  [KWELLO_ICON.X_ICON]: XIcon,
};

interface KwelloSvgIconProps {
  icon: KWELLO_ICON;
  className?: string;
  style?: CSSProperties;
  id?: string;
}

export function KwelloSvgIcon({ icon, className, style, id }: Readonly<KwelloSvgIconProps>) {
  const IconComponent = SVG_ICON_MAP[icon];
  if (!IconComponent) return;
  return <IconComponent className={className} style={style} id={id} />;
}

function getSvgStructure(svgNode: any) {
  if (Array.isArray(svgNode.props.children)) {
    const attributes = svgNode.props.children.map((child: any) => {
      let attr = '';
      let children = '';

      Object.keys(child.props ?? {}).forEach((key: string) => {
        if (key !== 'children') {
          attr += `${key}="${child.props[key]}"`;
        }
      });

      if (child.props?.children?.length) {
        children = getSvgStructure(child);
      }

      return { keys: attr, type: child.type, children };
    });

    return `${attributes.reduce((acc: string, attribute: any) => {
      if (attribute.children) {
        return `${acc}<${attribute.type} ${attribute.keys}>${attribute.children}</${attribute.type}>`;
      }

      return `${acc}<${attribute.type} ${attribute.keys} />`;
    }, '')}`;
  }

  let attributes = '';
  Object.keys(svgNode.props.children.props).forEach((key: string) => {
    if (key !== 'children') {
      attributes += `${key}="${svgNode.props.children.props[key]}"`;
    }
  });

  let children = '';

  if (svgNode.props.children?.props?.children?.length) {
    children = getSvgStructure(svgNode.props.children);
  }

  return children
    ? `<${svgNode.props.children.type} ${attributes}>${children}</${svgNode.props.children.type}>`
    : `<${svgNode.props.children.type} ${attributes} />`;
}

// USE THIS WITH CAUTION ONLY WHEN THERE IS NO WAY TO PASS ICON AS CHILDREN LIKE IN THE FLOATING ACTION BUTTON CAUSE THIS IS HACKY SOLUTION
// THIS IS NOT GUARANTEED THAT IT WILL WORK WITH ALL ICONS
// USER THE COMPONENT IF YOU CAN PASS THE ICON AS CHILDREN
export function getComplexIconRaw(icon: KWELLO_ICON | string): SVGIcon {
  // @ts-expect-error kendo patch
  const iconInstance = SVG_ICON_MAP[icon]({});
  const content = getSvgStructure(iconInstance);
  const result = {
    name: icon,
    viewBox: iconInstance.props.viewBox,
    // content: `<${iconInstance.props.children.type} ${attributes} />`,
    content,
  };
  return result;
}

export function getIconRaw(icon: KWELLO_ICON | string): SVGIcon {
  // @ts-expect-error kendo patch
  const iconInstance = SVG_ICON_MAP[icon]({});

  let attributes = '';
  Object.keys(iconInstance.props.children.props).forEach((key: string) => {
    attributes += `${key}="${iconInstance.props.children.props[key]}"`;
  });
  const result = {
    name: icon,
    viewBox: iconInstance.props.viewBox,
    content: `<path ${attributes} />`,
  };
  return result;
}
